import { render, staticRenderFns } from "./ApplicationOnHold.vue?vue&type=template&id=bdf48226&"
import script from "./ApplicationOnHold.vue?vue&type=script&lang=js&"
export * from "./ApplicationOnHold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports